import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';

import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';

//import Modaladdwork from './Modaladdwork';
//import Modaladdlist from './Modaladdlist';
//import Modaladdworkedit from './Modaladdworkedit';

import NumberFormat from 'react-number-format';
import LoadingOverlay from 'react-loading-overlay';
import { Steps } from 'antd';
import Modalsentroom from './Modalsentroom';
import Modaleditstatus from './Modaleditstatus';
import Modaleditstatus2 from './Modaleditstatus2';
import Timeend from './Timeend';
import Modaleditstatus4 from './Modaleditstatus4';



//import Modaladdworkpay from './Modaladdworkpay';

const { Step } = Steps;





export default class Homelucky extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',

                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],

                room:[],
                loading:false,
            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getwork = this.getwork.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttographic = this.senttographic.bind(this);
            this.senttowait = this.senttowait.bind(this);

            this.getroom = this.getroom.bind(this);
            
            
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

      

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = '/sorlalum/Checkstudentlist/'+id;

        }

        getwork (){
          this.setState({ loading:true})
            api.get('selectworksl.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ work: res.data,  loading: false })
            }) 
        }

        getroom (){
            this.setState({ loading:true})
              api.get('lkselectroom.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room: res.data,  loading: false })
              }) 
          }


        
        

       

        senttographic(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายกราฟฟิก",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttographic.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายกราฟฟิกสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }

           senttowait(event) {
            //  console.log(event.target.value);
             // const date = new Date().toISOString().slice(0, 10)
              const gg = event.target.value
              window.location.href = '/luckyresortkpp/Registerroom/'+gg+''

             console.log(gg)
             
           
             }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/sorlalum'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
        //this.getExpert()
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = '/Homelucky'
            } else {
  
            }

            setTimeout(function() { window.location=window.location;},180000)
          //    this.getwork();
              this.getroom();
          }
        

 

    render() {
     // console.log(this.state.code)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;

//            const date = year + '-' + month + '-' + day;
     //console.log(date)
       //Set date time format
       var startDate = new Date;
       var endDate   = new Date("2023-01-30 15:00:00");
       var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
     
       //Calculate time
       var days = Math.floor(seconds / (3600*24));
       var hrs_d   = Math.floor((seconds - (days * (3600*24))) / 3600);
       var hrs   = Math.floor(seconds / 3600);
       var mnts = Math.floor((seconds - (hrs * 3600)) / 60);
       var secs = seconds - (hrs * 3600) - (mnts * 60);
     
       //Add 0 if one digit
       if(hrs_d<10) hrs_d = "0" + hrs_d;
       if(mnts<10) mnts = "0" + mnts;
       if(secs<10) secs = "0" + secs;
    const  dds  = days + ' ' + hrs_d + ':' + mnts + ':' + secs;
  //  console.log(dds);

     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'รหัส',
            field: 'OLDID',
            sort: 'OLDID',
            width: 270
          },
          {
            label: 'รูป',
            field: 'PIC',
            sort: 'PIC'
            
          },
          {
            label: 'ชื่องาน',
            field: 'NAME',
            sort: 'NAME',
            width: 200
          },
           {
            label: 'วันที่เพิ่ม',
            field: 'DATES',
            sort: 'DATES',
            width: 200
          },
          {
            label: 'จำนวนเงิน',
            field: 'FACULTY',
            sort: 'FACULTY',
            width: 100
          },
         
          {
            label: 'ยกเลิก',
            field: 'status',
            sort: 'status',
            width: 100
          }

        ],

        rows: [...this.state.work.map((data, i) => (
          {
             list: <>{i+1}</>,
             OLDID: <>{data.code_workorder}</>,
             PIC: <><img src={`https://lookmaenamping.com/sorlalumbackend/uploads/${data.example_workorder}`} alt="thumbnails" className="img-thumbnail "  width="60" /></>,
             NAME: <>{data.name_workorder}<div> <br/>
             <Steps size="small" current={data.statusfinish_workorder}>
             <Step title="รับงาน" description={data.dateadd_workorder.substring(0, 10)} />
             <Step title="กราฟฟิก" description={data.datesentgf_workorder} />
             <Step title="พิมพ์" description={data.datesentmf_workorder} />
             <Step title="ติดตั้ง" description={data.dateinstall_workorder } />
             <Step title="เสร็จสิ้น" description={data.datefinish_workorder} />
             <Step title="ชำระเงิน" description={data.datepayfinish_workorder} />
             </Steps>
              </div>
             
             </>,
             DATES: <>{data.dateadd_workorder}</>,
             FACULTY: <><NumberFormat value={data.price_workorder}  displayType={'text'} thousandSeparator={true}  /></>,
             
             status: <>
             {data.statusfinish_workorder === '6' ?<></>:<> <MDBBtn color="dark" size="sm" value={data.id_workorder} onClick={this.senttowait} ><MDBIcon icon="spinner" /> รอดำเนินการ</MDBBtn></>}
            
             </>
             

            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   // searching ={true}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={20}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>
      
      let date11 = new Date();

        return (
          <LoadingOverlay
          active={this.state.loading}
          spinner
          text='Loading your data...'
          >
                <MDBContainer fluid >
  <h2 className="font-weight-bold  text-center">  ห้องพัก</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ใช้</p>
      <MDBRow >
          <div >
              {/* <Modaladdwork getwork={this.getwork}/>  */}
          </div>
        
        <MDBCol md="12" className="d-flex justify-content-center">
       
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
 

                    <MDBCardBody>
                    <MDBCardTitle className="text-center">  รายการสถานะห้องพัก</MDBCardTitle>

                        <div className="d-flex flex-wrap justify-content-center">
                        {this.state.room.map((room,index )  => 
                            <div className="p-2 col-example text-left"> 

                        {room.statusroom === '1' ?<>
                        <MDBCard color="success-color-dark" text="white" className="text-center" >
                                <MDBCardBody>
                               <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                               <p className="white-text">ว่าง</p> 
                               {/* <p className="white-text">ราคา {room.price}</p>  */}
                               <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn>
                               {/* <Modalsentroom /> */}
                                </MDBCardBody>
                            </MDBCard>
                        </>:<>
                        {room.statusroom === '2' ?<>
                                    {room.colortm === '0' ?<>
                                        <MDBCard color="danger-color-dark" text="white" className="text-center" >
                                              <MDBCardBody>
                                            <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                            <p className="white-text">ไม่ว่าง</p> 
                                            {/* <p className="white-text">ราคา {room.price}</p>  */}
                                            {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn> */}
                                            {/* <Modalsentroom /> */}
                                            {/* <Timeend id_room={room.id_room} /> */}
                                            <Modaleditstatus2 id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                              </MDBCardBody>
                                          </MDBCard>
                                     </>:<></>}
                                     {room.colortm === '1' ?<>
                                        <MDBCard color="indigo accent-4" text="white" className="text-center" >
                                              <MDBCardBody>
                                            <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                            <p className="white-text">2 ช.ม</p> 
                                            {/* <p className="white-text">ราคา {room.price}</p>  */}
                                            {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ1</MDBBtn> */}
                                            {/* <Modalsentroom /> */}
                                             <Timeend id_room={room.id_room} />
                                            <Modaleditstatus2 id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                              </MDBCardBody>
                                          </MDBCard>
                                     </>:<></>}
                                     {room.colortm === '2' ?<>
                                        <MDBCard color="secondary-color-dark" text="white" className="text-center" >
                                              <MDBCardBody>
                                            <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                            <p className="white-text">3 ช.ม</p> 
                                            {/* <p className="white-text">ราคา {room.price}</p>  */}
                                            {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ2</MDBBtn> */}
                                            {/* <Modalsentroom /> */}
                                            <Timeend id_room={room.id_room} />
                                            <Modaleditstatus2 id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                              </MDBCardBody>
                                          </MDBCard>
                                     </>:<></>}
                                     {room.colortm === '3' ?<>
                                        <MDBCard color="default-color-dark" text="white" className="text-center" >
                                              <MDBCardBody>
                                            <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                            <p className="white-text">เช้าเช้า-ออกเย็น</p> 
                                            {/* <p className="white-text">ราคา {room.price}</p>  */}
                                            {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn> */}
                                            {/* <Modalsentroom /> */}
                                            <Timeend id_room={room.id_room} />
                                            <Modaleditstatus2 id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                              </MDBCardBody>
                                          </MDBCard>
                                     </>:<></>}
                       
                        </>:<>
                              {room.statusroom === '3' ?<>
                                          <MDBCard color="warning-color" className="text-center" >
                                              <MDBCardBody>
                                            <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                            <p className="white-text">ทำความสะอาด</p> 
                                            {/* <p className="white-text">ราคา {room.price}</p>  */}
                                            <Modaleditstatus id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                            {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn> */}
                                            {/* <Modalsentroom /> */}
                                              </MDBCardBody>
                                          </MDBCard>
                              </>:<>
                                        { room.statusroom === '4' ?<>
                                        <MDBCard color="teal darken-4" className="text-center" >
                                              <MDBCardBody>
                                            <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                            <p className="white-text">รอคืนมัดจำ</p> 
                                            {/* <p className="white-text">ราคา {room.price}</p>  */}
                                            <Modaleditstatus4 id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                            {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn> */}
                                            {/* <Modalsentroom /> */}
                                              </MDBCardBody>
                                          </MDBCard>
                                        </>:<>
                                            { room.statusroom === '9' ?<>
                                            <MDBCard color="brown darken-3" className="text-center" >
                                                  <MDBCardBody>
                                                <h4 className="white-text">ห้องที่ {room.numberroom}</h4>  
                                                <p className="white-text">ไม่พร้อมรับ ({room.comment})</p> 
                                                {/* <p className="white-text">ราคา {room.price}</p>  */}
                                                <Modaleditstatus id_room={room.id_room} numberroom={room.numberroom} getroom={this.getroom} />
                                                {/* <MDBBtn color="dark" value={room.id_room} onClick={this.senttowait} ><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn> */}
                                                {/* <Modalsentroom /> */}
                                                  </MDBCardBody>
                                              </MDBCard>
                                            </>:<></>}
                                        </>}
                              </>}  
                        </>}
                         
                        
                        </>}
                           

                            </div>
                           )}
                        </div>


                    <br/>
                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                        <iframe src="http://localhost/luckybackend/check.php" height="20" width="300" title="Iframe Example"></iframe> 
                        {/* <iframe src="https://luckyresortkpp.com/luckybackend/check.php" height="20" width="300" title="Iframe Example"></iframe>  */}
                    </div>
                     {/* {persons} */}
                    </MDBCardBody>

                   
         </MDBCard>
        </MDBCol>


      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>

    


                   
                    </MDBContainer>
                    </LoadingOverlay>     
     
        )
    }
}
